// Calendar dates (YYYY-MM-DD) of the business: handovers happen in Israel, so "today" is today in
// Asia/Jerusalem, wherever the server or the device runs. A date-only value is never turned into
// an instant (no `new Date('YYYY-MM-DD')`, which is midnight UTC and shifts a day in Israel).
/** The time zone the business's calendar dates are in. */
export const BUSINESS_TIME_ZONE = 'Asia/Jerusalem';
const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;
/** The calendar date of `instant` in `timeZone`, as YYYY-MM-DD. */
export function calendarDate(instant, timeZone = BUSINESS_TIME_ZONE) {
    // en-CA formats as YYYY-MM-DD.
    return new Intl.DateTimeFormat('en-CA', {
        timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).format(instant);
}
/** `iso` moved by `days` calendar days (date arithmetic in UTC, so no daylight-saving shift). */
export function addDays(iso, days) {
    const match = ISO_DATE.exec(iso);
    if (match === null)
        throw new RangeError(`not a calendar date: ${iso}`);
    const at = new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3]) + days));
    return at.toISOString().slice(0, 10);
}
const PARTS = (timeZone) => new Intl.DateTimeFormat('en-US', {
    timeZone,
    hourCycle: 'h23',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
});
/** Minutes `timeZone` is ahead of UTC at `instant` (120 or 180 in Israel). */
function offsetMinutes(instant, timeZone) {
    const parts = PARTS(timeZone).formatToParts(new Date(instant));
    const get = (type) => Number(parts.find((p) => p.type === type)?.value ?? 0);
    const local = Date.UTC(get('year'), get('month') - 1, get('day'), get('hour'), get('minute'), get('second'));
    return Math.round((local - Math.floor(instant / 1000) * 1000) / 60_000);
}
/** The instant a calendar day (YYYY-MM-DD) starts in `timeZone` (midnight there). */
export function startOfDayIn(iso, timeZone = BUSINESS_TIME_ZONE) {
    const match = ISO_DATE.exec(iso);
    if (match === null)
        throw new RangeError(`not a calendar date: ${iso}`);
    const midnightUtc = Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
    const first = midnightUtc - offsetMinutes(midnightUtc, timeZone) * 60_000;
    // Across a daylight-saving change the offset at the guess may differ from the one at midnight.
    return new Date(midnightUtc - offsetMinutes(first, timeZone) * 60_000);
}
/** The time of day (HH:MM, 24 hours) of `instant` in `timeZone`. */
export function timeOfDayIn(instant, timeZone = BUSINESS_TIME_ZONE) {
    return new Intl.DateTimeFormat('en-GB', {
        timeZone,
        hourCycle: 'h23',
        hour: '2-digit',
        minute: '2-digit',
    }).format(instant);
}
//# sourceMappingURL=calendar-date.js.map